import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

// const Dato = ({styles, elemento}) => {
//   return(
//     <p style={styles.elemLis_1}>{elemento.numeroSerie} - {elemento.mac} => Estado: {elemento.estadoEquipo}   => {elemento.claseequ.codigoClaseEqu} {elemento.marcaequ.codigoMarcaEqu} {elemento.fabriequ.codigoFabriEqu}</p>
//   )};

//   const BodegaContrato = props => {
//     let estadoEq = ''
//     if(props.elemento.estadoEquipo==='BODEGA'){
//       estadoEq = props.elemento.bodega.codigoBodega + ' => ' + props.elemento.bodega.descrBodega
//     }
//     if(props.elemento.estadoEquipo==='CLIENTE'){
//       estadoEq = 'Contrato => ' + props.elemento.contrato
//     }

//   return(
//     <p>{estadoEq}</p>
//   )}

// const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
//   return (
//     <div className="ui middle aligned animated celled link list" style={styles.listaDer}>
//       <div className="item">
//         <List.Item onClick={(ev)=>handleClickidLista(ev, elemento)}>
//           <div className="right floated content" style={styles.elemLis_2}>
//             <div><BodegaContrato elemento={elemento} /></div>
//           </div>
//           <List.Header>
//             <div className="floated content" style={styles.subElemLis_1}>
//               <a className="header"><Dato styles={styles} elemento={elemento}/></a>
//             </div>
//           </List.Header>
//         </List.Item>
//       </div>
//     </div>
//   )
// };

// const Lista = ({styles, list, handleClickidLista}) => {
//   const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} handleClickidLista={handleClickidLista} elemento={elemento} key={elemento._id} />);
//   return(
//     <div>
//       {nivel1Detalle}
//     </div>
//   )
// };



//Clases
const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.numeroSerie}</td>
      <td className=''>{elemento.mac}</td>
      <td className='' style={{color: elemento.estadoEquipo==='CLIENTE'?'yellow':'#93291E', fontWeight: 'bold'}}>{elemento.estadoEquipo}</td>
      <td className='' style={{color: elemento.estadoEquipo==='CLIENTE'?'yellow':'#93291E', fontWeight: 'bold'}}>{elemento.estadoEquipo==='CLIENTE'?elemento.contrato:elemento.bodega.descrBodega}</td>
      <td className=''>{elemento.claseequ.descrClaseEqu}</td>
      <td className=''>{elemento.marcaequ.descrMarcaEqu}</td>
      <td className=''>{elemento.fabriequ.descrFabriEqu}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};


const ConfEqu2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a252501 = autorizacUA.findIndex( autorizac => autorizac === "252501" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Equipos" btnNuevo={a252501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '15%'}}>Serial</th>
                <th className='' style={{width: '15%'}}>Mac</th>
                <th className='' style={{width: '10%'}}>Ubicado en</th>
                <th className='' style={{width: '15%'}}>Ubicación</th>
                <th className='' style={{width: '15%'}}>Clase</th>
                <th className='' style={{width: '15%'}}>Marca</th>
                <th className='' style={{width: '15%'}}>Fabricante</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List>
    </div>
  )
};

export default ConfEqu2
